export const SystemName = {
	JobCategory: {
		Courier: "Courier"
	},
	LocationType: {
		Country: "Country",
		Port: "Port",
		Address: "Address",
		Terminal: "Terminal",
		Area: "Area",
		Park: "Park",
		Client: "Client",
		ClientPortPark: "ClientPortPark",
		Unpack: "Unpack",
		Pack: "Pack",
		Warehouse: "Warehouse",
		StorageYard: "StorageYard"
	},
	JobType: {
		ExportFCLTransportOrder: "ExportFCLTransportOrder",
		ImportFCLTransportOrder: "ImportFCLTransportOrder",
		ImportFAKTransportOrder: "ImportFAKTransportOrder",
		ExportFAKTransportOrder: "ExportFAKTransportOrder",
		LTLTrailerOrder: "LTLTrailerOrder"
	},
	Grid: {
		GeneralFreightNotYetDeparted: "MOVEPortalGeneralFreightNotYetDeparted"
	}
};
